// src/main.tsx
import React, { useState, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Splash } from './components/Splash'
import { Capacitor } from '@capacitor/core';

function setAppHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);

 }

function Root() {
  const [ready, setReady] = useState(false);
  const [heightSet, setHeightSet] = useState(false);

  useEffect(() => {
    const initApp = async () => {
      // Aguardar o DOM estar completamente carregado
      await new Promise(resolve => setTimeout(resolve, 100));

      // Primeira chamada
      setAppHeight();

      // Segunda chamada após um tempo maior (para safe areas)
      setTimeout(() => {
        setAppHeight();
        setHeightSet(true);
      }, 500);
    };

    initApp();

    // Adicionar as funções antes dos listeners
    const handleResize = () => {
      setTimeout(() => {
        setAppHeight();
      }, 100);
    };

    const handleOrientationChange = () => {
      setTimeout(() => {
        setAppHeight();
      }, 300); // Mais tempo para orientação
    };

    // Usar as novas funções nos listeners
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  if (!ready || !heightSet) {
    return <Splash onReady={() => setReady(true)} />;
  }

  // 3) Quando estiver pronto, renderiza o App dentro dos providers
  return (
    <React.StrictMode>
      <HelmetProvider>
        <BrowserRouter>
          <ThemeProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </React.StrictMode>
  )
}

const container = document.getElementById('root')!
createRoot(container).render(<Root />)